// extracted by mini-css-extract-plugin
export default {"menu":"NavBottom_menu__VCNrt","ant-menu-item-selected":"NavBottom_ant-menu-item-selected__8Z5M6","ant-menu-item-active":"NavBottom_ant-menu-item-active__jXEHK"};